export default class Tache {
  id!: number;
  type_tache!: string;
  type_tache_verbose!: string;
  date_creation!: string;
  date_traitement!: string;
  succes!: boolean | null;
  devis?: { id_4d: string, id: number };
  commande?: { id_4d: string, id: number };
  data!: {
    devis: { id_4d: string, id: number }[];
    commandes: { id_4d: string, id: number }[];
  };

  constructor(data: Params<Tache>) {
    Object.assign(this, data);
  }

  getDetails(): Tache[] {
    if (!this.data || !this.data.devis || !this.data.commandes) {
      return [this];
    }

    if (this.type_tache === "devis_to_cmd") {
      return this.data.devis.map((devis, index) => {
        const commande = this.data.commandes[index];
        return new Tache({
          ...this,
          devis,
          commande,
        });
      });
    }

    return [this];
  }
}
